import React, { Component } from 'react';

class AddBarThankYou extends Component {

  isValidated() {
    return true;
  }

  render() {
    return (
      <div className="fb-add-bar--thank-you">
        <h3>Thank you!</h3>
      </div>
    )
  }
}

export default AddBarThankYou;
